import { render, staticRenderFns } from "./Wellboats.vue?vue&type=template&id=34f550d2"
import script from "./Wellboats.vue?vue&type=script&lang=js"
export * from "./Wellboats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports